import {Component} from "@angular/core";
import {DynamicComponentBuilder} from "../renderer/dynamic-component-builder.service";
import {FormComponent} from "../renderer/model/form-component";
import {SESSION_COMPONENT} from "../renderer/model/dictionary";
import * as sample from "../sample.json";

@Component({
    selector: "json-editor",
    templateUrl: './json.editor.component.html'
})
export class JsonEditorComponent {

    prettyJsonComponentSession: string;

    constructor(public dynamicFormsBuilderService: DynamicComponentBuilder) {
        this.prettyJsonComponentSession = sessionStorage.getItem(SESSION_COMPONENT);
        if (!this.prettyJsonComponentSession) {
            this.prettyJsonComponentSession = JSON.stringify((sample as any).default, null, 2);
        }
    }

    loadJson(): void {
        const jsonComponent = this.prettyJsonComponentSession;
        sessionStorage.setItem(SESSION_COMPONENT, jsonComponent);
        const component: FormComponent = JSON.parse(jsonComponent);
        console.log('Component updated from JSON text editor');
        console.log(component);
        document.location.reload();
    }

    download(): void {
        console.log('Download');
        const dataString: string = encodeURIComponent(this.prettyJsonComponentSession);
        const filename = "demo.json";

        //detect whether the browser is IE/Edge or another browser
        if (window && window.navigator && window.navigator.msSaveOrOpenBlob) {
            //To IE or Edge browser, using msSave or OpenBlob method to download file.
            var blob = new Blob([dataString], { type: 'text/plain' });
            window.navigator.msSaveOrOpenBlob(blob, filename);
        } else {
            const anchor = document.createElement('a');
            anchor.download = filename;
            anchor.href = 'data:text/plain;charset=utf-8,' + dataString;
            anchor.style.display = 'none';

            document.body.appendChild(anchor);
            anchor.click();
            document.body.removeChild(anchor);
        }
    }

    getRows(): number {
        return this.prettyJsonComponentSession.split("\n").length;
    }
}
